<template>
  <div :class="['machine-owner-item', {'machine-owner-item--is-open': isOpen}]">
    <oie-interactive-list-item :class="['machine-owner-item__item']" @click.stop>
      <template #media>
        <oie-base-icon icon="user-avatar" size="l"></oie-base-icon>
      </template>
      <template #content>
        <div>
          <button class="h3 machine-owner-item__name" :aria-label="`Open machine owner ${customer.name}`" @click.stop="$emit('select-machine-owner', customer)">
            {{ customer.name }} {{ customer.endCustomerNumber ? `- ${customer.endCustomerNumber}` : '' }}
          </button>
          <p class="caption-faint">
            {{ `${customer.machines.length} ${tStatic('machines')}` }}
          </p>
        </div>
      </template>
      <template v-if="customer.machines.length" #actions>
        <oie-base-action
          class="machine-owner-item__toggle"
          theme="flat"
          :aria-expanded="isOpen ? 'true' : 'false'"
          :aria-controls="`customer-${customer.id}__machines`"
          :aria-label="t('toggleCustomer')"
          @click="isOpen = !isOpen">
          <oie-base-icon icon="chevron-down" :rotate="isOpen ? '180' : ''"></oie-base-icon>
        </oie-base-action>
      </template>
    </oie-interactive-list-item>
    <ul v-if="isOpen" :id="`customer-${customer.id}__machines`" class="machine-owner-item__list">
      <template v-for="machine in customer.machines">
        <li v-if="machine.display" :key="machine.id">
          <oie-machine-item :machine="machine" :show-favourite="showFavourite" v-on="$listeners">
            <template #actions>
              <slot name="machine-actions" :machine="machine">
              </slot>
            </template>
          </oie-machine-item>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>

export default {
  props: {
    customer: {
      type: Object,
      required: true
    },
    showFavourite: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  watch: {
    customer: {
      handler() {
        if (this.customer.expanded !== undefined) {
          this.isOpen = this.customer.expanded
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss">
.machine-owner-item {
  position: relative;
}

.machine-owner-item--is-open::after{
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: color(blue-1);
}

.machine-owner-item__item:hover {
  background-color: color(blue-5);

  .machine-owner-item__name {
    text-decoration: underline;
  }
}

.machine-owner-item__name{
  @include reset-button;
  text-align: left;
}

.machine-owner-item__name::after {
  content: "";
  position: absolute;
  top:0;
  bottom: 0;
  left: 0;
  right: 0;
}

.machine-owner-item__toggle {
  @container interactive-list-item (max-width: 600px) {
    position: absolute;
    top: 20px;
    right: 14px;
  }
}

.machine-owner-item__list {
  @include reset-list;
  margin-top: measure(half);
  margin-left: measure(quarter);
}

</style>
